/* eslint-disable */
import fileService from '@/shared/file/file-service';
import logService from '@/shared/entity-logger';
import { db, firebase } from '@/shared/firebase/firebase-init';
import _ from 'underscore'
import moment from 'moment'
import Cookies from 'js-cookie' // birthdate
import clubModel from '@/entities/club/club-model';
import teamModel from './team-model';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';

//  import teamModel from './team-model';
const NAME_ENTITY= 'team'
const KEY_TEAMS = 'teams'
const KEY_TEAM = 'team'
const KEY_CLUBS = 'clubs'
const KEY_CLUB= 'club'
const KEY_USER_MANAGER = 'usersManager'
const KEY_PLAYERS = 'players'

export default {
  list() {
    return new Promise((resolve) => {
      // eslint-disable-next-line
      db.ref(KEY_TEAMS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },

  listByClubId(clubId) {
    return new Promise((resolve) => {
      db.ref(KEY_CLUBS).child(clubId).child(KEY_TEAMS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },

  listByCategoryId(categoryId) {
    return new Promise((resolve) => {
      db.ref(KEY_TEAMS)
      .once('value').then((snapshot) => { 
        const list = []

        snapshot.forEach(childSnapshot => {
            list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },

  listByCategoryWithoutGroup() {
    return new Promise((resolve) => {
      db.ref(KEY_TEAMS)
      .once('value').then((snapshot) => { 
        const list = []

        var teamListByCategory = {}

        snapshot.forEach(childSnapshot => {
            var listTeam = teamListByCategory[childSnapshot.val().category.id]

            if(childSnapshot.val().hasGroup !== true) {
              list.push(childSnapshot.val())

              // Si es vacio, 
              if (_.isEmpty(listTeam)) {
                listTeam = []
              }

              listTeam.push(childSnapshot.val())

              teamListByCategory[childSnapshot.val().category.id] = listTeam
            }
        });
        resolve(teamListByCategory)
      });
    });
  },

  save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },

  find(id) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_TEAMS).child(id).once('value').then((snapshot) => { 
        const model = snapshot.val();
        
        if (!model) {
          return null;
        }
        resolve(model)
      })
    });
  },

  /**
   * Elimina un equipo, solo en el caso de que el club no tenga jugadores
   * @param {*} model 
   * @param {*} loggedUser 
   */
  destroy(model, loggedUser) {
    const modelToDestroy = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      deleted:  firebase.database.ServerValue.TIMESTAMP,
      deletedBy:  { id: loggedUser.id, email: loggedUser.email },
      modifiedBy:  { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {

         // 1. Comprobamos si el club tiene equipos 
      if (_.size(model.players) > 0) {
        reject(new Error("El equipo tiene jugadores asignados."))
      } else {
        var updates = {};
        updates['/' + KEY_CLUBS + '/' + model.club.id + '/' + KEY_TEAMS + '/'+ model.id] = null;
        updates['/' + KEY_TEAMS + '/' + model.id ] = null;

        if(modelToDestroy.club.manager){
          updates['/' + KEY_USER_MANAGER + '/' + modelToDestroy.club.manager.id + '/' + KEY_CLUBS + '/' + modelToDestroy.club.id + '/' + KEY_TEAMS + '/'+ modelToDestroy.id ] = null
        }

        db.ref().update(updates, (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            logService.log(modelToDestroy, "deleted", KEY_TEAMS, NAME_ENTITY)
            resolve()
          }
        })
      }
    })
  },

  update(model, loggedUser) {
    return new Promise((resolve, reject) => {

      const modelToUpdate = {
        ...model,
        modified:  firebase.database.ServerValue.TIMESTAMP,
        modifiedBy: { id: loggedUser.id, email: loggedUser.email }
      };

      var updates = {};
      updates['/' + KEY_CLUBS + '/' + modelToUpdate.club.id + '/' + KEY_TEAMS + '/'+ modelToUpdate.id] = teamModel.forClub(modelToUpdate);;
      updates['/' + KEY_TEAMS + '/' + modelToUpdate.id ] = modelToUpdate;

      // Si tiene club manager modificamos el equipo al manager
      if(modelToUpdate.club.manager){
        updates['/' + KEY_USER_MANAGER + '/' + modelToUpdate.club.manager.id + '/' + KEY_CLUBS + '/' + modelToUpdate.club.id + '/' + KEY_TEAMS + '/'+ modelToUpdate.id ] = teamModel.forClub(modelToUpdate);
      }

      // Si tiene jugadores, modificamos los jugadores de ese equipo
      if( model.players ) {
        _.each(model.players, (value, key, obj) => {
          updates['/' + KEY_PLAYERS + '/' + key + '/' + KEY_TEAM ] = teamModel.forSimple(modelToUpdate)
        })
      }

      db.ref().update(updates, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data saved successfully!
          // Logs
          logService.log(modelToUpdate, "modified", KEY_TEAMS, NAME_ENTITY)
          resolve()
        }
      })
    });
  },

  create(model, loggedUser) {
    
    console.log("<------ CREATE TEAM")
    console.log(model);
    
    var club = model.club
    var clubSimple = clubModel.forSimple(club)
    model.club = clubSimple

    const modelToSave = {
      ...model,
      id: db.ref(KEY_TEAMS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email } ,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    console.log("<--- ");
    console.log(modelToSave);
    console.log("<--- CLUBS ");
    console.log(club.teams);
    
    return new Promise((resolve, reject) => {
      var updates = {};
      updates['/' + KEY_CLUBS + '/' + modelToSave.club.id + '/' + KEY_TEAMS + '/'+ modelToSave.id] =  teamModel.forClub(modelToSave);;
      updates['/' + KEY_TEAMS + '/' + modelToSave.id ] = modelToSave;

      // Si tiene club manager creamos los equipos al manager
      if(modelToSave.club.manager){
        updates['/' + KEY_USER_MANAGER + '/' + modelToSave.club.manager.id + '/' + KEY_CLUBS + '/' + modelToSave.club.id + '/' + KEY_TEAMS + '/'+ modelToSave.id ] = teamModel.forClub(modelToSave);
      }
      
      db.ref().update(updates, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data saved successfully!
          logService.log(modelToSave, "created", KEY_TEAMS, NAME_ENTITY)
          resolve()
        }
      });
    });
  },

  exportAsPDF (team) {
    return new Promise((resolve, reject) => {
      console.log(team);

      /**
       * PLAYERS PARSING
       */

      var playerDataList = []
      var playerHeaderList = [
        [ 'Nombre deportivo', 'Nombre','Apellidos', 'Dni', 'Fecha de nacim.','Dorsal']
      ]
      
      // Players
      _.each(team.players, (player, key, list) => {
        var birthdate =  moment( player.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [player.namePublic, player.name, player.lastName, player.dni, birthdate, player.dorsal ]
        playerDataList.push(values)
      })
     
      /**
       * COACHES PARSING
       */

      var coachDataList = []
      var coachHeaderList = [
        [ 'Nombre','Apellidos', 'Dni']
      ]
      
      // Coaches
      _.each(team.coaches, (coach, key, list) => {
        // var birthdate =  moment( coach.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [coach.name,coach.lastName,coach.dni]
        coachDataList.push(values)
      })
     
      /**
       * TEAM MANAGERS PARSING
       */

      var teamManagerDataList = []
      var teamManagerHeaderList = [
        [ 'Nombre','Apellidos', 'Dni']
      ]
      
      // Managers
      _.each(team.teamManagers, (tm, key, list) => {
        // var birthdate =  moment( tm.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [ tm.name, tm.lastName, tm.dni]
        teamManagerDataList.push(values)
      })
     
      /*************************************************************
       *                                                           *
       *                CREAACION DEL DOC PDF                      *
       *                                                           *
       *************************************************************/

      var doc = new jsPDF()
      var docName = team.name + '_' + team.category.label + '_' + moment().format('DD-MM-YYYY') + '.pdf'
      var docTitle = "Datos del equipo"
      
      doc.setFontSize(22);
      doc.text(docTitle, 14, 20);
      doc.setFontSize(12);

      var img = new Image();
      img.addEventListener('load', function() {
         // doc.addImage(img, 'png', 10, 50);
      });
      img.src = '/static/logos/logo_dv7.png';
      doc.addImage(img, 'JPEG', 155, 12 , 40, 20);

      // Team data
      //  Labels
      doc.text("Nombre:", 14, 35);
      doc.text("Categoría:", 14, 40);
      doc.text("Club:", 14, 45);

      doc.text(team.name, 40, 35);
      doc.text(team.category.label, 40, 40);
      doc.text(team.club.name, 40, 45);

      // Team information

      // Coaches
      doc.setFontSize(14);
      doc.text("Entrenadores", 14,  60);
      doc.autoTable({ head: coachHeaderList, body: coachDataList,   startY: 65,  theme: 'plain', styles: {cellPadding: 0.5, fontSize: 10, halign: 'center' } });
      let finalYCoach = doc.previousAutoTable.finalY;
      
      // Team Managers
      doc.setFontSize(14);
      doc.text("Delegados", 14, finalYCoach + 15);
      doc.autoTable({head: teamManagerHeaderList, body: teamManagerDataList, startY: finalYCoach + 20,  theme: 'plain', styles: {cellPadding: 0.5, fontSize: 10, halign: 'center'} });
      let finalYTeamManager = doc.previousAutoTable.finalY;
      
      // Players
      doc.setFontSize(14);
      doc.text("Jugadores", 14, finalYTeamManager + 15);
      doc.autoTable({head: playerHeaderList, body: playerDataList,  startY: finalYTeamManager + 20, theme: 'plain',  styles: {cellPadding: 0.5, fontSize: 10,  halign: 'center'} });

      doc.save(docName);
      resolve()
    });
  },

  listOptions() {
    return new Promise((resolve) => {
      db.ref(KEY_TEAMS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          console.log("<-------");
          
          console.log( childSnapshot.key);
          
          const modelOption = {}
          modelOption.id = childSnapshot.key
          modelOption.name = childSnapshot.val().name,
          modelOption.label = childSnapshot.val().name + ' · ' + childSnapshot.val().category.label
          modelOption.club = childSnapshot.val().club
          modelOption.category = childSnapshot.val().category
          list.push(modelOption)
        });
        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/team/team-service.js